define('components/factory/models/VideoProductModel', [
    'components/factory/models/VideoModel'
], function(VideoModel) {

    var VideoProductModel = VideoModel.extend({
        // Extend VideoModel -> Fins more details on VideoModel

        defaults: _.extend({
            viewId: "video-product-id",         // Classic default viewId
            showVideoInfos: true,               // Show / Hide video details ( title, video stats, etc...)
            showStepIntoVideoInfos: false,      // Move step into mmm video
            title: null,                        // Video title ( ! if showVideoInfos false -> hidden )
            showSteps: true,                    // Show / Hide video steps
            startStep: -1,                      // Start video at this step
            youtubeSubscribe: false,            // Show / Hide youtube subscribe button
            youtubeChannel: {                   // Details of youtube subscribe button
                id: null,
                url: null,
                name: null,
                img: null,                      // If image is local
                externalImg: null               // If image is from youtube or external source (ex: Make Up How To)
            }
        }, VideoModel.prototype['defaults']) // jshint ignore:line

        // Add video.timecodes to define products associate
        // Add video.share to define share details of video
    });

    return VideoProductModel;
});
